import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Lightbox from '../components/Lightbox'
import { MENU_ITEMS } from '../lib/nav'
import { imageUrl } from '../lib/images'
import { HanddrawnArrow } from '../components/HanddrawnArrow'
import { ArcOrbitButton } from '../components/ArcOrbitButton'
import { useSmartSticky } from '../hooks/useSmartSticky'

const ALL_GALLERY_IMAGES = [
  { url: '/_assets/dsc00737_b28d969a.jpg', caption: 'Fællesskab og efterskoleliv' },
  { url: '/_assets/dsc00815_f86d9057.jpg', caption: 'Hyggelige stunder i hverdagen' },
  { url: '/_assets/dsc00901_0b4af1e4.jpg', caption: 'E-sport og gaming' },
  { url: '/_assets/dsc00981_2e69773d.jpg', caption: 'Fokus og samarbejde' },
  { url: '/_assets/dsc00991-1_bd637d45.jpg', caption: 'Madlavning i skolekøkkenet' },
  { url: '/_assets/dsc00998-1_20e0f98a.jpg', caption: 'Bagning og gode råvarer' },
  { url: '/_assets/dsc01007_be359ec3.jpg', caption: 'Kreativt værksted' },
  { url: '/_assets/dsc01025_c49f68ab.jpg', caption: 'Outdoor og natur' },
  { url: '/_assets/dsc01030_e6621df6.jpg', caption: 'Bålmad og friluftsliv' },
  { url: '/_assets/dsc01047_578d4989.jpg', caption: 'Sport og boldspil i hallen' },
  { url: '/_assets/dsc01094_7872ed6d.jpg', caption: 'Samvær og nye venner' },
  { url: '/_assets/dsc01126-0_1c1545bb.jpg', caption: 'Efterskolens omgivelser' },
  { url: '/_assets/dsc00973_1268c8a9.jpg', caption: 'Glade elever på skolen' },
  { url: '/_assets/dsc01164_b0f51fa9.jpg', caption: 'Undervisning og læring' },
  { url: '/_assets/dsc01037_cec92b3d.jpg', caption: 'Skolens grønne områder' },
  { url: '/_assets/dsc00755_e31a980f.jpg', caption: 'Fællessang og samling' },
  { url: '/_assets/dsc00965_27a565d8.jpg', caption: 'Aktiviteter i fritiden' },
  { url: '/_assets/dsc01421-0_e9196308.jpg', caption: 'Udflugter og lejrskole' },
  { url: '/_assets/dsc00976_f5bc3924.jpg', caption: 'Kreativ fordybelse' },
  { url: '/_assets/dsc01109_3b5b4903.jpg', caption: 'Stærkt sammenhold' },
  { url: '/_assets/efterskole-outdoor-elever-haengekoeje_245ff15c.jpg', caption: 'Hængekøjehygge i marsken' },
  { url: '/_assets/dsc01454_44d09c6e.jpg', caption: 'Aftensamling på skolen' },
  { url: '/_assets/dsc00940_ce2ac6ab.jpg', caption: 'Gode oplevelser sammen' },
  { url: '/_assets/dsc00774_4dd65579.jpg', caption: 'Stemning og efterskoleår' },
  { url: '/_assets/sloejdlokale-emmerske-efterskole-toender_723c6219.jpg', caption: 'Træ- og metalværksted' },
  { url: '/_assets/elever-efterskole-soenderjylland_ec11372b.jpg', caption: 'Fællesskab i Sønderjylland' },
  { url: '/_assets/elever-undervisning-emmerske-efterskole-toender_02d69491.jpg', caption: 'Tryg undervisning på små hold' },
  { url: '/_assets/header-vaerelserne_ece5c18a.jpg', caption: 'Værelserne med eget bad og toilet' },
]

export default function GalleryPage() {
  const [lightboxIndex, setLightboxIndex] = useState(null)
  const [openSections, setOpenSections] = useState({ 'om-os': true })
  const sidebarRef = useSmartSticky({ topOffset: 104, bottomOffset: 32 })

  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }))
  }

  return (
    <div className="w-full bg-white">
      {/* Top Banner */}
      <section className="relative bg-[#36454F] text-white pt-36 sm:pt-44 lg:pt-52 pb-24 sm:pb-32 lg:pb-36 min-h-[440px] sm:min-h-[500px] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="/_assets/elever-fra-emmerske-efterskole_e0454220.jpg"
            alt="Billeder fra Emmerske Efterskole"
            className="w-full h-full object-cover"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                'linear-gradient(to right, rgba(54,69,79,0.85) 0%, rgba(54,69,79,0.65) 50%, rgba(47,111,115,0.45) 100%)',
            }}
          />
        </div>

        <div className="background-blob -bottom-24 -right-24 bg-white/10" aria-hidden="true" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <span className="font-['Shadows_Into_Light'] text-2xl sm:text-3xl text-[#DCEEF2] -rotate-2 inline-block mb-1 drop-shadow-sm">
            Glimt fra efterskolelivet
          </span>
          <h1 className="font-['Plus_Jakarta_Sans'] text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight leading-tight">
            Billeder
          </h1>
          <p className="mt-3 text-[#DCEEF2] text-base sm:text-lg max-w-2xl leading-relaxed font-medium">
            Se et udvalg af fotos fra hverdagen, undervisningen, værkstederne, lejrskolen og det
            stærke fællesskab på Emmerske Efterskole.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <Link to="/rundvisning" className="organic-btn !min-h-0 !py-3.5 !px-7 text-sm sm:text-base group">
              <i className="fa-solid fa-calendar-check" aria-hidden="true" />
              <span>Book rundvisning</span>
              <HanddrawnArrow width={36} height={18} className="organic-btn__arrow" />
            </Link>
            <a
              href="tel:74724433"
              className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-white/20 hover:bg-white text-white hover:text-[#36454F] font-bold text-sm backdrop-blur-md border border-white/40 transition-colors"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              <span>74 72 44 33</span>
            </a>
          </div>
        </div>
      </section>

      {/* Main Content Area */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          
          {/* Main Gallery Area (8 cols) */}
          <div className="lg:col-span-8 min-w-0">
            <article className="py-2">
              <div className="mb-10">
                <span className="font-['Shadows_Into_Light'] text-2xl text-[#007A53] block mb-1">
                  Minder for livet
                </span>
                <h2 className="font-['Plus_Jakarta_Sans'] text-3xl sm:text-4xl font-black text-[#36454F] tracking-tight">
                  Dagligdagen på Emmerske Efterskole
                </h2>
                <p className="text-[#36454F]/80 text-base sm:text-lg mt-2 leading-relaxed">
                  Gå på opdagelse i vores billedgalleri. Klik på et foto for at se det i fuld skærm.
                </p>
              </div>

              {/* Masonry fotoflow med organiske kurver */}
              <div className="columns-1 sm:columns-2 md:columns-3 gap-5 space-y-5">
                {ALL_GALLERY_IMAGES.map((img, idx) => (
                  <div
                    key={idx}
                    onClick={() => setLightboxIndex(idx)}
                    className="break-inside-avoid relative rounded-3xl overflow-hidden group cursor-pointer shadow-md hover:shadow-2xl transition-all duration-300 bg-stone-100 hover:scale-[1.02] border-2 border-white"
                  >
                    <img
                      src={imageUrl(img.url, 'width=800,quality=80,format=auto')}
                      alt={img.caption || `Emmerske Efterskole foto ${idx + 1}`}
                      loading="lazy"
                      className="w-full h-auto object-cover group-hover:scale-108 transition-transform duration-700 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-5">
                      <p className="text-white text-xs sm:text-sm font-bold drop-shadow">
                        {img.caption}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA-knapper */}
              <div className="mt-14 pt-8 border-t border-[#DCEEF2] flex flex-wrap items-center gap-4">
                <a
                  href="mailto:ee@eeskole.dk"
                  className="organic-btn !min-h-0 !py-3.5 !px-7 text-sm inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-envelope" aria-hidden="true" />
                  <span>Skriv til os</span>
                </a>
                <a
                  href="tel:74724433"
                  className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border-2 border-[#2F6F73] text-[#2F6F73] hover:bg-[#DCEEF2]/60 font-bold text-sm transition-colors"
                >
                  <i className="fa-solid fa-phone text-[#007A53]" aria-hidden="true" />
                  <span>Ring til os</span>
                </a>
              </div>
            </article>
          </div>

          {/* Right Sticky Sidebar (4 cols) */}
          <aside className="lg:col-span-4">
            <div ref={sidebarRef} className="space-y-6 smart-sticky-sidebar">
              <div className="bg-[#DCEEF2]/60 rounded-3xl p-6 sm:p-7 shadow-sm border border-[#DCEEF2] space-y-6">
              <div className="border-b border-[#2F6F73]/20 pb-4">
                <span className="font-['Shadows_Into_Light'] text-xl text-[#2F6F73] block mb-1">
                  Udforsk skolen
                </span>
                <h3 className="font-['Plus_Jakarta_Sans'] text-xl font-black text-[#36454F]">
                  Sider på skolen
                </h3>
              </div>

              <nav aria-label="Sider på Emmerske Efterskole" className="space-y-1.5">
                {MENU_ITEMS.filter((item) => !item.isCta && !item.external).map((item, idx) => {
                  const hasChildren = Array.isArray(item.children) && item.children.length > 0
                  const isOmOs = item.href === '/om-os'
                  const isOpen = !!openSections['om-os'] && isOmOs

                  return (
                    <div key={idx} className="border-b border-[#2F6F73]/15 last:border-0 pb-1 last:pb-0">
                      {hasChildren ? (
                        <div>
                          <button
                            type="button"
                            onClick={() => toggleSection('om-os')}
                            className={`w-full flex items-center justify-between text-left px-3.5 py-2.5 rounded-2xl text-sm font-extrabold transition-all cursor-pointer ${
                              isOpen
                                ? 'bg-[#007A53] text-white shadow-md'
                                : 'text-[#36454F] hover:bg-white/80'
                            }`}
                          >
                            <span>{item.label}</span>
                            <i
                              className={`fa-solid fa-chevron-down text-xs transition-transform duration-200 ${
                                isOpen ? 'rotate-180' : ''
                              }`}
                              aria-hidden="true"
                            />
                          </button>

                          {isOpen && (
                            <div className="ml-3 pl-3 border-l-2 border-[#007A53]/30 space-y-1 mt-1 py-1">
                              {item.children.map((sub, sIdx) => (
                                <Link
                                  key={sIdx}
                                  to={sub.href}
                                  className="block px-3 py-1.5 rounded-lg text-xs font-bold text-[#36454F] hover:text-[#007A53] hover:bg-white/60 transition-colors"
                                >
                                  {sub.label}
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <Link
                          to={item.href}
                          className="block px-3.5 py-2.5 rounded-2xl text-sm font-extrabold text-[#36454F] hover:bg-white/80 transition-colors"
                        >
                          {item.label}
                        </Link>
                      )}
                    </div>
                  )
                })}
              </nav>

              <div className="pt-4 border-t border-[#2F6F73]/20 space-y-3">
                <ArcOrbitButton
                  to="/rundvisning"
                  icon={<i className="fa-solid fa-calendar-check" />}
                  arrow={false}
                  className="w-full !min-h-[48px]"
                >
                  Book rundvisning
                </ArcOrbitButton>
                <a
                  href="tel:74724433"
                  className="w-full flex items-center justify-center gap-2 py-2.5 px-4 rounded-full bg-white text-[#36454F] hover:text-[#007A53] text-xs font-extrabold shadow-sm transition-colors"
                >
                  <i className="fa-solid fa-phone text-[#007A53]" />
                  <span>Ring 74 72 44 33</span>
                </a>
              </div>
            </div>
          </div>
        </aside>

        </div>
      </main>

      {/* Lightbox til visning af billeder i fuld skærm */}
      {lightboxIndex !== null && (
        <Lightbox
          images={ALL_GALLERY_IMAGES.map((img) => img.url)}
          captions={ALL_GALLERY_IMAGES.map((img) => img.caption)}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </div>
  )
}
